import { TeamMember } from "../../sections/team";
import styles from "./teammember.module.scss";

const TeamCard: React.FC<TeamMember> = ({ name, title, photo, bio, linkedin }) => (
  <div className={styles.teamCard}>
    <a href={linkedin} target="_blank" rel="noreferrer" className={styles.link}>
      <div className={styles.imageContainer}>
        <img src={photo} alt={name} />
      </div>
      <h3 className={styles.name}>{name}</h3>
      <p className={styles.title}>{title}</p>
    </a>
    <p className={styles.bio}>{bio}</p>
  </div>
);

export default TeamCard;
